import { PageLayout } from '@spotify/confidence-core-react';

import { ResourceNotFoundContent } from '../../../../ResourceNotFoundContent';
import { useResourcePageLayoutProps } from './useResourcePageLayoutProps';

// eslint-disable-next-line @spotify-confidence/page-requires-tracking -- rendered inside already-tracked pages via ResourceGuard; tracking happens at the parent
export const ResourceNotFoundErrorPage = () => {
  const pageLayoutProps = useResourcePageLayoutProps();

  return (
    <PageLayout {...pageLayoutProps}>
      <ResourceNotFoundContent variant="resource" />
    </PageLayout>
  );
};
